define('ProductVariationJson.Helper', [
    'jQuery',
    'underscore'
], function ProductVariationJsonHelper(
    jQuery,
    _
) {
    'use strict';
    var IN_STOCK_SCHEMA = 'https://schema.org/InStock';
    var OUT_STOCK_SCHEMA = 'https://schema.org/OutOfStock';
    var PRE_ORDER_STOCK_SCHEMA = 'https://schema.org/PreOrder';
    var PRODUCT_VARIANT_SCHEMA = {
        '@type': 'Product',
        'name': '',
        'sku': '',
        'mpn': '',
        'image': '',
        'offers': {
            '@type': 'Offer',
            'url': '',
            'priceCurrency': '',
            'price': '',
            'availability': ''
        },
        'additionalProperty': []
    };
    return {
        isMatrixItem: function isMatrixItem(pdp) {
            var children = pdp.getAllMatrixChilds();
            return children && children.length;
        },
        getMandatoryOptions: function getMandatoryOptions(itemOptions) {
            return _.filter(itemOptions, function filter(option) {
                return option.isMandatory;
            }) || [];
        },
        getCombinedOptionsUrl: function getCombinedOptionsUrl(urls) {
            var finalUrl = '';
            _.each(urls, function(url, index) {
                if (index === 0) {
                    finalUrl = url; // keep first URL as is
                } else {
                    var parts = url.split('?');
                    if (parts[1]) {
                        finalUrl += '&' + parts[1]; // append only query string
                    }
                }
            });
            return finalUrl;
        },
        getStockAvailability: function getStockAvailability(item, availabilityBackOrder) {
            if (item.ispurchasable && !item.isinstock) {
                return availabilityBackOrder === 'PreOrder' ? PRE_ORDER_STOCK_SCHEMA : IN_STOCK_SCHEMA;
            } else if (item.isinstock) {
                return IN_STOCK_SCHEMA;
            }
            return OUT_STOCK_SCHEMA;
        },
        getProductVariants: function getProductVariants(options) {
            var itemInfo = options.pdp.getItemInfo();
            var item = itemInfo && itemInfo.item;
            var newJson;
            var itemOptions = item && item.options;
            var children = options.pdp.getAllMatrixChilds();
            var prodVariants = [];
            var skuUrls;
            var variant;
            var mandatoryOptions = itemOptions.length && this.getMandatoryOptions(itemOptions);
            var self = this;
            if (mandatoryOptions && mandatoryOptions.length && children.length) {
                newJson = JSON.parse(JSON.stringify(options.jsonValues));
                _.each(children, function each(childItem) {
                    skuUrls = [];
                    variant =  JSON.parse(JSON.stringify(PRODUCT_VARIANT_SCHEMA));
                    variant.name = item.keyMapping_name || item.storedisplayname2;
                    variant.sku = childItem.keyMapping_sku || childItem.itemid;
                    variant.mpn = childItem.vendorname || '';
                    variant.image = item.keyMapping_thumbnail && item.keyMapping_thumbnail.url;
                    variant.offers.priceCurrency = options.currency;
                    variant.offers.price = (childItem.onlinecustomerprice_detail && childItem.onlinecustomerprice_detail.onlinecustomerprice) || 0;
                    variant.offers.availability = self.getStockAvailability(childItem, options.availabilityBackOrder);
                    _.each(mandatoryOptions, function each(mandatoryOption) {
                        var currentOptionValue = childItem[mandatoryOption.itemOptionId];
                        // only continue if childItem has value for this mandatory option
                        if (!currentOptionValue) {
                            return;
                        }
                        var mapObj = _.findWhere(options.itemOptionsMap, { fieldId: mandatoryOption.cartOptionId });
                        var mapObjAdditional = _.findWhere(options.additionalOptionsMap, { fieldId: mandatoryOption.cartOptionId });
                        if (mapObj) {
                            variant[mapObj.label] = currentOptionValue + (mapObj.units ? (' ' + mapObj.units) : '');
                        } else if (mapObjAdditional) {
                            variant.additionalProperty.push({
                                '@type': 'PropertyValue',
                                'name': mapObjAdditional.label,
                                'value': currentOptionValue + (mapObjAdditional.units ? (' ' + mapObjAdditional.units) : '')
                            });
                        } else {
                            variant[mandatoryOption.label] = currentOptionValue;
                        }
                        // find matching value object
                        var foundValueObj = _.find(mandatoryOption.values, function find(val) {
                            return val.label === currentOptionValue;
                        });
                        if (foundValueObj) {
                            skuUrls.push(foundValueObj.url);
                        }
                    });
                    if (skuUrls.length) {
                        variant.offers.url = self.getCombinedOptionsUrl(skuUrls);
                    }
                    prodVariants.push(variant);
                });
                newJson['@type'] = 'ProductGroup';
                newJson.productGroupID = item.itemid;
                newJson.hasVariant = prodVariants;
                newJson.url = options.shopUrl + '/' + item.urlcomponent;
                delete newJson.sku;
                delete newJson.offers;
                return newJson;
            }
            return options.jsonValues;
        }
    };
});
